<template>
    <div class="card mb-3">
        <div class="card-body" v-if="!editing">
            <div class="row">
                <h4 class="card-title col-md-12">Location {{index+1}}</h4>
            </div>
            <div class="row">
                <p
                    v-for="(item, key, index) in filteredLocation"
                    :key="'location-card-'+index"
                    :class="smallColumns.includes(key) ? 'col-md-6' : 'col-md-12'"
                >
                    <!--<strong>{{key}}:</strong>  
                    {{item}} -->
                    <span v-html="LocationItemDisplay(index,key,item)" />
                    
                </p>
            </div>
        </div>
        <div class="card-body" v-if="editing">
            <form>
                <fieldset v-if="type == 'street'">
                    <label class="form-label">On-street location is used for:</label>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="StreetRoadUseType"
                            v-model="street.StreetRoadUseType"
                            name="streetRoadUseType"
                            :options="[{text:'Filming',value:'filming'},{text:'Parking',value:'parking'},{text:'Both',value:'both'}]"
                            :isRequired="type == 'street'"
                            :inline="true"
                        />
                    </div>
                    <div class="form-row">
                        <TypeaheadInput
                            inputId="road"
                            v-model="street.StreetRoad"
                            labelText="Street name"
                            :options="roadList"
                            :wrapperClasses="['col-md-10']"
                            @optionSelected="getIntersections"
                        />
                    </div>
                    <div class="form-row">
                        <TypeaheadInput
                            inputId="Intersection_From"
                            v-model="street.Intersection_From"
                            labelText="From"
                            helpText="First crossroad"
                            :options="intersectionList"
                            :wrapperClasses="['col-md-10']"
                        />
                    </div>
                    <div class="form-row">
                        <TypeaheadInput
                            inputId="Intersection_To"
                            v-model="street.Intersection_To"
                            labelText="To"
                            helpText="Second crossroad"
                            :options="intersectionList"
                            :wrapperClasses="['col-md-10']"
                        />
                    </div>
                    <label class="form-label">Side of road</label>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="street.StreetRoadSide"
                            v-model="street.StreetRoadSide"
                            name="streetRoadSide"
                            :options="[{text:'One',value:'O'},{text:'Both',value:'B'}]"
                            :isRequired="type == 'street'"
                            :inline="true"
                        />
                    </div>
                    <label class="form-label">Will you be parking overnight?</label>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="OverNight"
                            v-model="street.OverNight"
                            name="Overnight"
                            :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                            :isRequired="type == 'street'"
                        />
                    </div>
                    <label class="form-label">Start date and time</label>
                    <DateTimeInput
                        inputId="StreetRoadStartDate"
                        v-model="street.StreetRoadStartDate"
                        :srOnly="true"
                        :defaultTime="{hour:7,minute:0}"
                    />
                    <label class="form-label">End date and time</label>
                    <DateTimeInput
                        inputId="StreetRoadEndDate"
                        v-model="street.StreetRoadEndDate"
                        :srOnly="true"
                        :defaultTime="{hour:23,minute:0}"
						:startDate="street.StreetRoadStartDate"
                        :validation="[{type:'before',value: street.StreetRoadStartDate, msg: 'Your end date can\'t be before your start date.'}]"
                    />
                </fieldset>
                <fieldset v-if="type == 'lot'">
                    <label class="form-label">Parking lot is used for:</label>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="LotUseType"
                            v-model="lot.LotUseType"
                            name="LotUseType"
                            :options="[{text:'Filming',value:'filming'},{text:'Parking',value:'parking'},{text:'Both',value:'both'}]"
                            :isRequired="type == 'lot'"
                            :inline="true"
                        />
                    </div>
                    <div class="form-row">
                        <TextInput
                            inputId="Location"
                            v-model="lot.Location"
                            labelText="Lot address"
                            helpText="Example: 300 City Centre Dr."
                        />
                    </div>
                    <div class="form-row">
                        <NumberInput
                            inputId="NumOfSpaces"
                            v-model="lot.NumOfSpaces"
                            labelText="Number of spaces needed"
                        />
                    </div>

                    <label class="form-label">Is this a privately owned lot?</label>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="lot.Private"
                            v-model="lot.Private"
                            name="Private"
                            :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                        />
                    </div>

                    <label class="form-label">Will you be parking overnight?</label>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="OverNight"
                            v-model="lot.OverNight"
                            name="Overnight"
                            :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                        />
                    </div>
                    <label class="form-label">Start date and time</label>
                    <DateTimeInput
                        inputId="LocationStartDate"
                        v-model="lot.LocationStartDate"
                        :srOnly="true"
                        :defaultTime="{hour:7,minute:0}"
                    />
                    <label class="form-label">End date and time</label>
                    <DateTimeInput
                        inputId="LocationEndDate"
                        v-model="lot.LocationEndDate"
						:startDate="lot.LocationStartDate"
                        :srOnly="true"
                        :defaultTime="{hour:23,minute:0}"
                        :validation="[{type:'before',value: lot.LocationEndDate, msg: 'Your end date can\'t be before your start date.'}]"
                    />
                </fieldset>
            </form>
        </div>
        <div class="card__utility-bar card-footer" v-if="!review">
            <button
                class="btn btn-sm btn-outline-danger"
                v-if="!confirmDelete && !editing"
                @click="confirmDelete = true"
            >Delete</button>
            <div v-if="confirmDelete">
                Are you sure?
                <button class="btn-confirm" @click="deleteLocation">Yes</button> /
                <button class="btn-confirm" @click="confirmDelete = false">No</button>
            </div>
            <button
                class="btn btn-sm btn-outline-primary"
                @click="editing = true;"
                v-if="!confirmDelete && !editing"
            >Edit</button>
            <button
                class="btn btn-sm btn-outline-danger"
                @click="cancelEditing"
                v-if="editing"
            >Cancel</button>
            <button
                class="btn btn-sm btn-success"
                @click="modifyLocation"
                v-if="!confirmDelete && editing"
            >Save</button> 
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import RadioInput from "@/components/inputs/RadioInput.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import NumberInput from "@/components/inputs/NumberInput.vue";
import TypeaheadInput from "@/components/inputs/TypeaheadInput.vue";
import DateTimeInput from "@/components/inputs/DateTimeInput.vue";
import moment from 'moment';

export default {
    name: "location-card",
    components: {
        RadioInput,
        TextInput,
        NumberInput,
        TypeaheadInput,
        DateTimeInput
    },
    props: {
        location: Object,
        index: Number,
        review: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            editing: false,
            confirmDelete: false,
            locationInfo: {},
            smallColumns: [
                "Parking overnight",
                "Privately owned",
                "Start",
                "End"
            ],
            street: {
                StreetRoadUseType: "filming",
                StreetRoad: "",
                Intersection_From: "",
                Intersection_To: "",
                StreetRoadStartDate: "",
                StreetRoadEndDate: "",
                StreetRoadSide: "",
                
                OverNight: "",
                type: "street"
            },
            lot: {
                LotUseType: "parking",
                Location: "",
                NumOfSpaces: 0,
                LocationStartDate: "",
                LocationEndDate: "",
                Private: "",
                OverNight: "",
                LocationType: "parking",
                type: "lot"
            },
            cardSubmitted: false,
            errors: [],
            prevQuery: "",
        };
    },
    computed: {
        //type: ({ location }) => location.type,
        type()
        {
            return this.location.type;
        },
        filteredLocation() {
            let updatedLocation = {};
            Object.keys(this.location).forEach(key => {
                switch (key) {
                    case "StreetRoadUseType":
                        updatedLocation["On-street/road is used for"] = this.location[key] == "both" ? this.location[key] + " (parking and filming)" : this.location[key];
                        break;
                    case "LotUseType":
                        updatedLocation["Parking lot is used for"] = this.location[key] == "both" ? this.location[key] + " (parking and filming)" : this.location[key];
                        break;
                    case "StreetRoad":
                        updatedLocation["Street name"] = this.location[key];
                        break;
                    case "Intersection_From": {
                        updatedLocation["From"] = this.location[key];
                        break;
                    }
                    case "Intersection_To": {
                        updatedLocation["To"] = this.location[key];
                        break;
                    }
                    case "StreetRoadStartDate": {
                        updatedLocation["Start"] = dayjs(
                            this.location[key]
                        ).format("MMMM D, YYYY");
                        break;
                    }
                    case "StreetRoadEndDate": {
                        updatedLocation["End"] = dayjs(
                            this.location[key]
                        ).format("MMMM D, YYYY");
                        break;
                    }
                    case "StreetRoadSide": {
                        let loc = this.location[key] == "B" ? "Both" : "One";
                        updatedLocation["Road side"] = loc;
                        break;
                    }
                    case "StreetRoadUseType": {
                        break;
                    }
                    case "Location": {
                        updatedLocation["Address"] = this.location[key];
                        break;
                    }
                    case "NumOfSpaces": {
                        updatedLocation["Spaces needed"] = this.location[key];
                        break;
                    }
                    case "LocationStartDate": {
                        updatedLocation["Start"] = dayjs(
                            this.location[key]
                        ).format("MMMM D, YYYY");
                        break;
                    }
                    case "LocationEndDate": {
                        updatedLocation["End"] = dayjs(
                            this.location[key]
                        ).format("MMMM D, YYYY");
                        break;
                    }
                    case "Private": {
                        updatedLocation["Privately owned"] = this.location[key];
                        break;
                    }
                    case "OverNight": {
                        updatedLocation["Parking overnight"] = this.location[
                            key
                        ];
                        break;
                    }
                    case "LocationType": {
                        break;
                    }
                }
            });
            delete updatedLocation.type;

            return updatedLocation;
        },
        roadList() {
            return this.$store.getters.getRoadList;
        },
        intersectionList() {
            return this.$store.getters.getIntersectionList;
        },
    },
    methods: {
        deleteLocation() {
            this.confirmDelete = false;
            this.$store.dispatch("REMOVE_LOCATION", this.index);
        },
        modifyLocation() {
            if (this._errorsExist()) {
                return false;
            }
            this.editing = false;
            this.$store.dispatch("MODIFY_LOCATION", {
                index: this.index,
                newInfo: this[this.type]
            });
        },
        editLocation() {
            this.editing = true;
            this[this.type] = Object.assign({}, this.location);
        },
        cancelEditing() {
            /*
            const template = {
                street: {
                    StreetRoad: "",
                    Intersection_From: "",
                    Intersection_To: "",
                    StreetRoadStartDate: "",
                    StreetRoadEndDate: "",
                    StreetRoadSide: "",
                    StreetRoadUseType: "filming",
                    type: "street"
                },
                lot: {
                    Location: "",
                    NumOfSpaces: 0,
                    LocationStartDate: "",
                    LocationEndDate: "",
                    Private: "",
                    OverNight: "",
                    LocationType: "parking",
                    type: "lot"
                }
            };
            this[this.type] = template[this.type];
            */
            this.editing = false;
        },
        getIntersections(road) {
            // this.street.Intersection_From = "";
            // this.street.Intersection_To = "";
            this.$store.dispatch("GET_INTERSECTION_LIST", road);
        },
        LocationItemDisplay(index,key,value)
        {
            //console.log(index + '. ' + key + '...' + value);
            if(key == 'Start' || key == 'End')
            {
                var currentDate = moment().format("YYYY-MM-DD");
                var dateVal = moment(value).format("YYYY-MM-DD");
                if (moment(dateVal).isBefore(currentDate))  //Or use: isSameOrBefore
                {
                    return '<strong>' + key + '</strong>:&nbsp;<span class="alert-danger">' + value + '</span>&nbsp;<span class="invalid-feedback"><i class="fas fa-info-circle"> Date can\'t be in the past.</span>';
                } 
                else
                {
                    return '<strong>' + key + '</strong>:&nbsp;' + value;
                }
            }
            else
            {
                return '<strong>' + key + '</strong>:&nbsp;' + value;
            }
        }
    },
    mounted() {
        this[this.type] = Object.assign({}, this.location);
    },
    watch: {
        location()
        {
            this[this.type] = Object.assign({}, this.location);
        }
        
    }
};
</script>